import React, { useEffect, useState } from 'react';
import NewsNoticeCard from './NewsNoticeCard';

const NoticeNewsBoard = () => {
    const [type, setType] = useState('notice');
    const [data, setData] = useState([]);

    useEffect(() => {
        fetch('/data/notice.json')
            .then(res => res.json())
            .then(data => setData(data.filter(item => item.type === type)))
    }, [type]);

    const selectData = (select) => {
        setType(select);
    };

    return (
        <div className='bg-green-100 py-12'> {/* ✅ Background color applied */}
            <div className='container mx-auto px-4 lg:px-16'>

                {/* Button Group */}
                <div className='flex justify-center mb-8'>
                    <div className="btn-group">
                        <button 
                            className={`px-6 py-2 text-lg font-medium transition-colors duration-300 rounded-l-full ${type === "notice" ? "bg-primary text-white" : "border border-primary text-primary"}`}
                            onClick={() => selectData('notice')}
                        >
                            Notice
                        </button>
                        <button 
                            className={`px-6 py-2 text-lg font-medium transition-colors duration-300 rounded-r-full ${type === "news" ? "bg-primary text-white" : "border border-primary text-primary"}`}
                            onClick={() => selectData('news')}
                        >
                            News
                        </button>
                    </div>
                </div>

                {/* Notice & News Board */}
                <div className='border rounded-2xl border-primary border-2 mx-2 lg:mx-24 p-6 lg:p-12 h-64 lg:h-96 md:h-96 overflow-auto bg-white shadow-md'>
                    <table className='table-auto w-full'>
                        <tbody>
                            {data.length > 0 ? (
                                data.map(item => <NewsNoticeCard key={item._id} item={item} />)
                            ) : (
                                <tr>
                                    <td className="text-center text-gray-500 py-4">No data available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
};

export default NoticeNewsBoard;
